import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Resolution886ReportService } from '@/infra/services/resolution-886-report';
import { QUERY_KEYS } from '@/utils/query-keys';

interface GeneratePDFParams {
	organization_id: string;
	company_id: string;
	report_id: string;
	review_id: string;
	locale: string;
	exclude_fields?: string[];
}

const Service = Resolution886ReportService.getInstance();

export const useGeneratePDF = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (params: GeneratePDFParams) => Service.generatePDF(params),
		onSuccess: (data: any) => {
			let archive = document.createElement('a');
			archive.target = '_blank';
			archive.href = data.url;
			archive.click();
			archive.remove();
			queryClient.invalidateQueries([QUERY_KEYS.GENERATE_RESOLUTION_886_PDF]);
		},
		onError: () => {
			message.error(I18n.get('Error generating PDF'));
		}
	});
};
